import React from 'react'

import { InputText } from 'primereact/inputtext'

import { ConfigurableComponent } from '../../../../../utils/wrapper'
import { useConfigContext } from '../../../../ui-config'
import { useDeliveryForecastItemById } from '../../../data'
import { Splits } from './Splits'

type Props = {
  deliveryForecastId: string
  id: string
}

export const Position: React.FC<Props> = ({ deliveryForecastId, id }) => {
  const { uiConfig: config } = useConfigContext()
  const { data: deliveryForecastItem, isLoading } = useDeliveryForecastItemById(
    deliveryForecastId,
    id,
  )

  // ************************************************************
  // components
  // ************************************************************
  // buyerProductId
  const buyerProductIdLabel = (
    <label htmlFor="buyerProductId" className="text-sm"></label>
  )

  const buyerProductIdComponent = (
    <InputText
      id="buyerProductId"
      value={deliveryForecastItem?.BuyerProductId}
      className="w-full"
      disabled
    />
  )

  const buyerProductIdWrapper = (
    <ConfigurableComponent
      config={config.deliveryForecast.acceptDeliveryForecast}
      component={buyerProductIdComponent}
      label={buyerProductIdLabel}
      className="col-12 md:col-6 lg:col-4"
      isLoading={isLoading}
    />
  )

  // buyerProductDescription
  const buyerProductDescriptionLabel = (
    <label htmlFor="buyerProductDescription" className="text-sm"></label>
  )

  const buyerProductDescriptionComponent = (
    <InputText
      id="buyerProductDescription"
      value={deliveryForecastItem?.BuyerProductDescription}
      className="w-full"
      disabled
    />
  )

  const buyerProductDescriptionWrapper = (
    <ConfigurableComponent
      config={config.deliveryForecast.acceptDeliveryForecast}
      component={buyerProductDescriptionComponent}
      label={buyerProductDescriptionLabel}
      className="col-12 md:col-6 lg:col-4"
      isLoading={isLoading}
    />
  )

  return (
    <>
      <div className="formgrid grid mb-3">
        {/* buyerProductIdWrapper */}
        {buyerProductIdWrapper}

        {/* buyerProductDescriptionWrapper */}
        {buyerProductDescriptionWrapper}
      </div>

      <Splits items={deliveryForecastItem?.Splits} isLoading={isLoading} />
    </>
  )
}
